module.exports = __webpack_public_path__ + "media/images/elements/Elemntas_8-e4e697b54ecac76908a61ab975d10705.svg";